import "./summaryTable.css";
import MultiSelectSearchCmp from "../../MultiSelectSearchCmp";
import { Tooltip } from "@mui/joy";
import UpArrowIcon from "../../../../../svg/Ads_Dashboard_Developement2/UpArrownIcon/elements.svg";
import DownArrowIcon from "../../../../../svg/Ads_Dashboard_Developement2/DownArrowIcon/elements.svg";
import ImageCmp from "../../ImageCmp";
import { useEffect, useRef, useState } from "react";

const UpdatedSummaryTable = ({ 
  setSort,         // For saving state of sort
  sort,            // For Showing ASC & DESC Arrows 
  data,            // Summary Table Data 
  product_details_headerData,    // For Product Details Column Name in Header
  column,          // Metrics Column Name for accessing values from table data
  headerDateArr,    // For Metrics Column Name in Header
  period_type,     // For Formating Date, Week, Month, All in Header 
  categories, // For Showing all data in Filter DropDown in Table
  setCategories, // For sorting Categories Object arrays based on Search Input field
  sel_categories, // For showing Selected data in Filter DropDown in Table
  sel_categoriesdrawer,
  setSel_Categories, // For Updating data in Filter DropDown in Table
  onSelCategory,
  DropDownApplyBtn,
  DrillThroughHandler,
  metrics_row_data,
  cellClickHandler
}) => {
  console.log('--->', data, product_details_headerData)
    const [drill_through_enty_cols, setDrill_Through_entry_Cols] =  useState(["principal_category","main_category","category", "sub_category","product_name"])
  
    const leftRef = useRef(null);
    const rightRef = useRef(null);
    const isSyncing = useRef(false);
    const productDetailRowRef = useRef(null);

    const syncScroll = (source, target) => {
      if (!isSyncing.current) {
        isSyncing.current = true;
        target.current.scrollTop = source.current.scrollTop;
        // Small delay to release lock after scroll update
        setTimeout(() => {
          isSyncing.current = false;
        }, 0);
      }
    };
  
    const handleLeftScroll = () => {
      syncScroll(leftRef, rightRef);
    };
  
    const handleRightScroll = () => {
      syncScroll(rightRef, leftRef);
    };

  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatWeek = (weekStr) => { 
    const [yearno, monthno, week, weekno ] = weekStr?.split("-");

    const months = new Map([
      [1, "January"], [2, "February"], [3, "March"], [4, "April"],
      [5, "May"], [6, "June"], [7, "July"], [8, "August"],
      [9, "September"], [10, "October"], [11, "November"], [12, "December"]
  ]);

    return `W${weekno?.slice(1)}, ${months.get(Number(monthno))?.slice(0,3) }'${yearno?.slice(2)}`;
  }

  const formatMonth = (monthStr) => {
    const [yearno, monthno ] = monthStr?.split("-");

    const months = new Map([ 
      [1, "January"], [2, "February"], [3, "March"], [4, "April"],
      [5, "May"], [6, "June"], [7, "July"], [8, "August"],
      [9, "September"], [10, "October"], [11, "November"], [12, "December"]
  ]);
    return `${months.get(Number(monthno))?.slice(0,3)} ${yearno}`;
  }

  const calculateLeftPosition = (columnType) => {
    let left = 0;

    // Iterate over keys up to the current column to sum widths
    for (const column of product_details_headerData) {
      if (column.type === columnType) break; // Stop when reaching the current column
      left += column.width;
    }

    return left;
  };

  useEffect(() => {
          if (productDetailRowRef.current) {
            productDetailRowRef.current.scrollLeft = productDetailRowRef.current.scrollWidth;
          }
  }, [product_details_headerData]);

  const Rec = (data, level, arr, product_details_cols_length) => {
    let new_arr = [...arr, {type: data?.type, name: data?.name}];
    return (
      <div style={{ display: "flex"}} >
        <div
          className="cell flex p-1 items-top justify-center gap-2 self-stretch "
          style={{
            width: product_details_headerData?.find((item) => item.type === data.type)?.width,
            position: "sticky",
            left: calculateLeftPosition(data.type),
            borderRight: product_details_cols_length - 1 === level ? "0px" : "1px solid #EAEAED",
            borderBottom: "1px solid #EAEAED",
            backgroundColor: "#FFF",
            height: level === product_details_cols_length - 1 ? "50px" : "100%",
          }}
          onClick={ () =>{ 
                if(data?.type === "principal_category" || data?.type === "main_category" || data?.type === "category" || data?.type === "sub_category" || data?.type === "product_name" || data?.type === "platform_code"){
                  cellClickHandler(new_arr);
                }
              }}
        >
          <div
            className="flex justify-end items-start w-full h-full "
            style={{
              // backgroundColor: "skyblue",
              position: "relative",
            }}
          >
            <div
              className="flex items-center gap-1 w-full"
              style={{
                color:
                data?.type === "platform_code" || (data?.type=== "targeting" && data?.name?.startsWith('asin=')) || (data?.type=== "targeting" && data?.name?.startsWith('asin-expanded=')) || (data?.type === "searchterm" && data?.name?.startsWith('b0'))
                  ? "#1565C0"
                  : "var(--Text-Primary-Black, #1C1C1E)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "12px",
              position: "sticky",
              top: "50%",
              textDecoration: (data?.type === "platform_code" || (data?.type=== "targeting" && data?.name?.startsWith('asin=')) || (data?.type=== "targeting" && data?.name?.startsWith('asin-expanded=')) || (data?.type === "searchterm" && data?.name?.startsWith('b0'))) && "underline",
              justifyContent: "start"
              }}
            >
              {data.type === "platform_code" && (
                // <img
                //   src="/Platform_Code_Icon.png"
                //   className="h-[30px] flex-shrink-0"
                //   alt="Platform Code Icon"
                // />
              <ImageCmp url={`https://www.amazon.in/dp/${data?.name}`}/>

              )}
              {/* <Tooltip
                title={<IconTooltip name={data.name} />}
                placement="top"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "4px 8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "8px",
                }}
              > */}
                 {data?.type === "platform_code" ? (
                  <a href={`https://www.amazon.in/dp/${data?.name}`} target="_blank" rel="noopener noreferrer" className="flex text-wrap break-words break-all justify-start" onClick={(e) => e.stopPropagation()}>
                  {/* {data.name.length > 11
                    ? data.type !== "platform_code"
                      ? `${data.name.substring(0, 11)}...`
                      : `${data.name}`
                    :`${data.name}`} */}
                            {data?.name}
                </a>
                ) : data?.type === "targeting" && data?.name?.startsWith('asin=') ||  data?.type === "targeting" && data?.name?.startsWith('asin-expanded=') ? (
                  <a href={`https://www.amazon.in/dp/${data?.name?.split('=')[1]?.replace(/"/g, '')}`} target="_blank" rel="noopener noreferrer" className="flex w-full text-wrap break-words break-all justify-start">
                  {/* {data.name.length > 11
                    ? data.type !== "platform_code"
                      ? `${data.name.substring(0, 11)}...`
                      : `${data.name}`
                    :`${data.name}`} */}
                            {data?.name}
                </a>
                ) : data?.type === "searchterm" && data?.name?.startsWith('b0')  ? (
                  <a href={`https://www.amazon.in/dp/${String(data?.name)?.toLocaleUpperCase()}`} target="_blank" rel="noopener noreferrer" className="flex w-full text-wrap break-words break-all justify-start">
                    {/* {data.name.length > 11
                      ? data.type !== "platform_code"
                        ? `${data.name.substring(0, 11)}...`
                        : `${data.name}`
                      :`${data.name}`} */}
                            {data?.name}
                  </a>
                ) : ( 
                  <div className="flex w-full text-wrap break-words break-all justify-start"
                  >
                  {/* {data.name.length > 11
                    ? data.type !== "platform_code"
                      ? `${data.name.substring(0, 11)}...`
                      : `${data.name}`
                    :`${data.name}`} */}
                            {data?.name}
                </div>)
                }
              {/* </Tooltip> */}

              {/* // Non Functional Button */}
              {/* <div
                className="flex p-1 h-fit items-center gap-1 rounded-[4px]"
                style={{
                  background: "#F2F2F5",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    d="M5.75 7.4V4.6C5.75 4.48333 5.7 4.40417 5.6 4.3625C5.5 4.32083 5.40833 4.34167 5.325 4.425L4.1 5.65C4 5.75 3.95 5.86667 3.95 6C3.95 6.13333 4 6.25 4.1 6.35L5.325 7.575C5.40833 7.65833 5.5 7.67917 5.6 7.6375C5.7 7.59583 5.75 7.51667 5.75 7.4ZM2.5 10.5C2.225 10.5 1.98958 10.4021 1.79375 10.2063C1.59792 10.0104 1.5 9.775 1.5 9.5V2.5C1.5 2.225 1.59792 1.98958 1.79375 1.79375C1.98958 1.59792 2.225 1.5 2.5 1.5H9.5C9.775 1.5 10.0104 1.59792 10.2063 1.79375C10.4021 1.98958 10.5 2.225 10.5 2.5V9.5C10.5 9.775 10.4021 10.0104 10.2063 10.2063C10.0104 10.4021 9.775 10.5 9.5 10.5H2.5ZM8 9.5H9.5V2.5H8V9.5ZM7 9.5V2.5H2.5V9.5H7Z"
                    fill="#97979A"
                  />
                </svg>
              </div> */}
              {drill_through_enty_cols?.includes(data?.type) && (
                  <div
                      className="flex p-1 h-fit items-center gap-1 rounded-[4px]"
                      style={{
                      background: "#F2F2F5",
                      cursor: "pointer"
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent the click from bubbling up
                        DrillThroughHandler(new_arr);
                      }}
                  >
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 9C1.85833 9 1.73958 8.95208 1.64375 8.85625C1.54792 8.76042 1.5 8.64167 1.5 8.5C1.5 8.35833 1.54792 8.23958 1.64375 8.14375C1.73958 8.04792 1.85833 8 2 8H7.5C7.64167 8 7.76042 8.04792 7.85625 8.14375C7.95208 8.23958 8 8.35833 8 8.5C8 8.64167 7.95208 8.76042 7.85625 8.85625C7.76042 8.95208 7.64167 9 7.5 9H2ZM9.45 8.15L7.65 6.35C7.55 6.25 7.5 6.13333 7.5 6C7.5 5.86667 7.55 5.75 7.65 5.65L9.45 3.85C9.54167 3.75833 9.65833 3.7125 9.8 3.7125C9.94167 3.7125 10.0583 3.75833 10.15 3.85C10.2417 3.94167 10.2875 4.05833 10.2875 4.2C10.2875 4.34167 10.2417 4.45833 10.15 4.55L8.7 6L10.15 7.45C10.2417 7.54167 10.2875 7.65833 10.2875 7.8C10.2875 7.94167 10.2417 8.05833 10.15 8.15C10.0583 8.24167 9.94167 8.2875 9.8 8.2875C9.65833 8.2875 9.54167 8.24167 9.45 8.15ZM2 6.5C1.85833 6.5 1.73958 6.45208 1.64375 6.35625C1.54792 6.26042 1.5 6.14167 1.5 6C1.5 5.85833 1.54792 5.73958 1.64375 5.64375C1.73958 5.54792 1.85833 5.5 2 5.5H6C6.14167 5.5 6.26042 5.54792 6.35625 5.64375C6.45208 5.73958 6.5 5.85833 6.5 6C6.5 6.14167 6.45208 6.26042 6.35625 6.35625C6.26042 6.45208 6.14167 6.5 6 6.5H2ZM2 4C1.85833 4 1.73958 3.95208 1.64375 3.85625C1.54792 3.76042 1.5 3.64167 1.5 3.5C1.5 3.35833 1.54792 3.23958 1.64375 3.14375C1.73958 3.04792 1.85833 3 2 3H7.5C7.64167 3 7.76042 3.04792 7.85625 3.14375C7.95208 3.23958 8 3.35833 8 3.5C8 3.64167 7.95208 3.76042 7.85625 3.85625C7.76042 3.95208 7.64167 4 7.5 4H2Z" fill="#97979A"/>
                      </svg>
                  </div>
                )}
            </div>
          </div>
        </div>
        {data?.children?.length > 0 && (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {data.children.map((data) => {
              return Rec(data, level + 1, new_arr, product_details_cols_length);
            })}
          </div>
        )}
        {/* {data?.row?.length > 0 && (
          <div style={{ display: "flex", flexDirection: "column", height: '100%' }}>
            {data.row.map((dataobj) => {
              return (
                <div style={{ display: "flex", height: '100%'}}>
                  {dataobj.map((obj) => {
                    return (
                      <div style={{ display: "flex", height: '100%' }}>
                        {column?.map(({ headerName, field }) => {
                          return (
                            <div
                              style={{
                                display: "flex",
                                width: "120px",
                                padding: "16px 24px",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "2px",
                                backgroundColor: "#FFF",
                                borderBottom: "1px solid #EAEAED",
                                borderRight: "1px solid #EAEAED",
                              }}
                            >
                              <div
                                style={{
                                  color: "var(--Text-Primary-Black, #1C1C1E)",
                                  textAlign: "right",
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  lineHeight: "18px",
                                }}
                              >
                                {obj[obj?.date]?.[field]}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        )} */}
      </div>
    );
  };

  const onSortHandler = (ipdate, ipmatrice_name) => {
    setSort((prev) => {
      if (prev.matrice_name !== ipmatrice_name || prev.sortbydate !==  ipdate) {
        return {
          matrice_name: ipmatrice_name,
          sortby: "ASC",
          sortbydate: ipdate
        };
      }
      else if (prev.matrice_name === ipmatrice_name && prev?.sortbydate === ipdate) {
        if (prev.sortby === "ASC") {
          return {
            ...prev,
            sortby: "DESC",
          };
        } else if (prev.sortby === "DESC") {
          return {
            ...prev,
            sortby: "",
          };
        } else if (prev.sortby === "") {
          return {
            ...prev,
            sortby: "ASC",
          };
        }
      }
    })
  }

  const getProduct_Details_Section_width = () => {
    let new_width = 0;

    product_details_headerData?.map((item) => {
        new_width += item?.width
    })
    return new_width;
  } 

  const [rsmatricearr, setRsMatricearr] = useState(["spend", "sales", "gross_sales", "organic_sales"]);
  return (
    <div className="" style={{
        width: "calc(100vw - 71px - 46px)",
        // height: "576px",
        height: "calc(100vh - 280px)",
      }}>
        <div className=" flex"
        style={{
            width: "calc(100vw - 71px - 46px)",
            // height: "576px",
            height: "calc(100vh - 280px)",
        }}
        >
            {/* Left Side */}
            <div className=" flex flex-col" 
            ref={productDetailRowRef}
            style={{
              borderRight: "1px solid #EAEAED",
              borderLeft: "1px solid #EAEAED",
              overflow:"auto",
              position: "relative",
              boxShadow: "1px 0px 10px 4px rgba(130,130,130,0.05)",
              // maxHeight: "calc(100vh - 455px)",
              maxWidth: 350,
            }}>
                <div className="h-[87px] relative" style={{
                    // maxWidth:600,
                    width: getProduct_Details_Section_width()
                }}>
                    <div
                    className="flex h-[44px] px-22 py-2 justify-center items-center gap-2 self-stretch"
                    style={{
                      textAlign: "center",
                      background: "#F3F3F7",
                      borderBottom: "1px solid #EAEAED",
                      position:"sticky",
                      top:0,
                      left:0,
                      maxWidth: 350,
                    }}
                >
                    <div
                    style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        textAlign: "center",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "14px",
                    }}
                    >
                    Product Details
                    </div>
                </div>
                <div style={{ display: "flex", width: "100%"}}>
                    {product_details_headerData &&
                    product_details_headerData?.length > 0 &&
                    product_details_headerData?.map((d, index) => {

                        return (
                        <div
                        className="cell flex h-[44px] px-2 py-2 justify-between items-center gap-1"
                        style={{
                            width: d?.width,
                            backgroundColor: "#F3F3F7",
                            borderRight: product_details_headerData?.length - 1 === index ? "0px" : "1px solid #EAEAED",
                            position: "relative",
                        }}
                        key={d?.title_name}
                        >
                        <div
                            style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            textAlign: "start",
                            fontFamily: "Inter",
                            fontSize: "10px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "14px",
                            }}
                        >
                            {d?.title_name}
                        </div>
                        <MultiSelectSearchCmp
                            searchcat={d?.type}
                            childrenarr={categories[d?.type]}
                            setCategories={setCategories}
                            selectedarr={sel_categoriesdrawer[d?.type]}
                            sel_categories={sel_categories}
                            setSel_Categories={setSel_Categories}
                            onSelCategory={onSelCategory}
                            DropDownApplyBtn={DropDownApplyBtn}
                        />
                        </div>
                    )})}
                </div>
                {/* <div
                    className="flex h-[80px] px-6 py-2 items-center gap-2 self-stretch "
                    style={{
                    backgroundColor: "#FAFAFA",
                    //   borderBottom: "1px solid #EAEAED",
                    position:"sticky",
                    top:0,
                    left:0,
                    maxWidth: 600,
                    }}
                >
                    <div
                    style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "16px",
                    }}
                    >
                    Subtotal
                    </div>
                </div> */}
                </div>

                <div className="flex flex-col"
                ref={leftRef}
                onScroll={handleLeftScroll}
                style={{
                    // borderRight: "1px solid #EAEAED",
                    width: getProduct_Details_Section_width(),
                    // height: "512px",
                    height: "calc(100vh - 280px - 87px)",
                    overflowX:"auto",
                    scrollbarWidth:"none",
                }}>
                    {data.map((data) => {
                        return Rec(data, 0, [], product_details_headerData?.length);
                    })}
                </div>
            </div>

            {/* Right Side */}
            <div 
            className="flex flex-col"
            style={{
                maxWidth:`calc(100vw - 71px - 46px - ${product_details_headerData?.length < 3 ? getProduct_Details_Section_width() : 350}px)`,
                overflow:"auto",
                position:"relative",
                // maxHeight: "calc(100vh - 455px)",
                borderRight: "1px solid #EAEAED",
            }}>
                <div className="flex h-[87px]">
                    {headerDateArr.length > 0 &&
                    headerDateArr?.map((data,index1) => {
                        return (
                        <div className="flex flex-col">
                            <div
                            className="cell flex h-[44px] px-6 py-2 justify-center items-center gap-2 self-stretch"
                            style={{
                                textAlign: "center",
                                background: "#F3F3F7",
                            }}
                            >
                            <div
                                style={{
                                color: "var(--Text-Primary-Black, #1C1C1E)",
                                textAlign: "center",
                                fontFamily: "Inter",
                                fontSize: "10px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                lineHeight: "14px",
                                }}
                            >
                                {period_type === "DAILY" ? formatDate(data?.date) : period_type === "WEEKLY" ? formatWeek(data?.date) : period_type === "MONTHLY" ? formatMonth(data?.date) : period_type === "ALL" && "ALL"}
                            </div>
                            </div>

                            <div className="flex ">
                            <div style={{ display: "flex" }}>
                                {data?.matrices_arr?.map((matrice, index2) => {
                            
                                return (
                                    <div
                                    key={matrice?.matrice_backend_name}
                                    className="cell flex h-[44px] px-1 py-2 justify-end items-center gap-1"
                                    style={{
                                        width: 80,
                                        backgroundColor: "#F3F3F7",
                                        borderRight: index2 === data?.matrices_arr?.length - 1 ? "1px solid #EAEAED" :"0px",
                                        cursor:"pointer"
                                    }}
                                    onClick={() => onSortHandler(data.date, matrice?.matrice_backend_name)}
                                    >
                                    <div
                                        style={{
                                        color: "var(--Text-Primary-Black, #1C1C1E)",
                                        textAlign: "end",
                                        fontFamily: "Inter",
                                        fontSize: "10px",
                                        fontStyle: "normal",
                                        fontWeight: 700,
                                        lineHeight: "14px",
                                        }}
                                    >
                                        {matrice?.matrice_name}
                                    </div>
                                    {sort.sortbydate === data?.date && sort.matrice_name === matrice?.matrice_backend_name &&
                                        sort.sortby === "ASC" && (
                                        <img
                                            src={UpArrowIcon}
                                            alt="Icon"
                                            style={{ cursor: "pointer" }}
                                        />
                                        )}
                                    {sort.sortbydate === data?.date && sort.matrice_name === matrice?.matrice_backend_name &&
                                        sort.sortby === "DESC" && (
                                        <img
                                            src={DownArrowIcon}
                                            alt="Icon"
                                            style={{ cursor: "pointer" }}
                                        />
                                        )}
                                    </div>
                                );
                                })}
                            </div>
                            </div>
                        </div>
                        );
                    })}
                </div>

                <div className="flex flex-col" 
                    ref={rightRef}
                    onScroll={handleRightScroll}
                    style={{
                        width: column?.length * 80 * headerDateArr?.length,
                        // height: "calc(100vh - 455px - 165x)",
                        // height: "512px",
                        height: "calc(100vh - 280px - 87px)",
                        overflowX:"auto",
                        backgroundColor:"white",
                        scrollbarWidth:"none"
                    }}>
                        {metrics_row_data?.length > 0 && (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                {metrics_row_data?.map((dataobj) => {
                                return (
                                    <div style={{ display: "flex", height: '100%'}}>
                                    {dataobj?.map((obj, index1) => {
                                        return (
                                        <div style={{ display: "flex", height: '100%' }}>
                                            {column?.map(({ headerName, field }, index2) => {
                                            return (
                                                <div
                                                style={{
                                                    display: "flex",
                                                    width: "80px",
                                                    height: "50px",
                                                    padding: "4px",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "end",
                                                    gap: "2px",
                                                    backgroundColor: "#FFF",
                                                    borderBottom: "1px solid #EAEAED",
                                                    borderRight: index2 === column?.length - 1 ? "1px solid #EAEAED" : "0px",
                                                }}
                                                >
                                                <div
                                                    style={{
                                                    color: "var(--Text-Primary-Black, #1C1C1E)",
                                                    textAlign: "end",
                                                    fontFamily: "Inter",
                                                    fontSize: "12px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "16px",
                                                    }}
                                                >
                                                    {rsmatricearr?.includes(field) ? `₹ ${obj[obj?.date]?.[field]}` : `${obj[obj?.date]?.[field]}`}
                                                </div>
                                                </div>
                                            );
                                            })}
                                        </div>
                                        );
                                    })}
                                    </div>
                                );
                                })}
                            </div>
                        )}
                </div>   
            </div>
        </div>
    </div>
    
    //   {/* Row of table  */}
    //   <div style={{ display: "flex", width: "fit-content" }}>
    //     <div style={{ display: "flex", flexDirection: "column" }}>
    //       {data.map((data) => {
    //         return Rec(data, 0);
    //       })}
    //     </div>
    //   </div>
    // </div>
  );
};

export default UpdatedSummaryTable;
